import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import InnerHustle, { ISSUE_CONTENT_LIVE } from "@/pages/InnerHustle";
import SixthSensePage from "@/pages/SixthSensePage";
import RealHustlePage from "@/pages/RealHustlePage";
import PassportToPeacePage from "@/pages/PassportToPeacePage";
import InRotationPage from "@/pages/InRotationPage";
import ArchivePage from "@/pages/ArchivePage";
import StoryComingSoon from "@/pages/StoryComingSoon";
import AdminInbox from "@/pages/AdminInbox";

const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      // Wait a beat for the page to render before scrolling
      const id = hash.replace("#", "");
      const tryScroll = (attempts = 0) => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        } else if (attempts < 20) {
          setTimeout(() => tryScroll(attempts + 1), 50);
        }
      };
      tryScroll();
    } else {
      window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    }
  }, [pathname, hash]);
  return null;
};

function App() {
  return (
    <BrowserRouter>
      <ScrollManager />
      <Routes>
        <Route path="/" element={<InnerHustle />} />
        <Route path="/subscribe" element={<InnerHustle scrollTo="subscribe" />} />
        <Route path="/story/sixth-sense" element={ISSUE_CONTENT_LIVE ? <SixthSensePage /> : <StoryComingSoon />} />
        <Route path="/story/real-hustle" element={ISSUE_CONTENT_LIVE ? <RealHustlePage /> : <StoryComingSoon />} />
        <Route path="/story/passport-to-peace" element={ISSUE_CONTENT_LIVE ? <PassportToPeacePage /> : <StoryComingSoon />} />
        <Route path="/story/in-rotation" element={ISSUE_CONTENT_LIVE ? <InRotationPage /> : <StoryComingSoon />} />
        <Route path="/archive" element={<ArchivePage />} />
        <Route path="/admin/inbox" element={<AdminInbox />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
